export default {
  svg: 'flag',
  label: 'Set Goal',
  type: 'control',
  action: 'goal'
}
